<template>
  <header class="t-header" :class='{"is-fixed": isfixed}'>
    <div class="header-left" @click="onEmit('left')">
      <slot name="left">
        <i v-if="tleft.icon" class="iconfont" :class="'icon-' + tleft.icon"></i>
        <span v-if="tleft.text">{{tleft.text}}</span>
      </slot>
    </div>
    <slot name="center">
      <h1 v-show="title" @click="onEmit('center')">{{title}}</h1>
    </slot>
    <div class="header-right" @click="onEmit('right')">
      <slot name="right">
        <span key="1" v-if="tright.text">{{tright.text}}</span>
        <i key="2" v-if="tright.icon" class="iconfont" :class="'icon-' + tright.icon"></i>
      </slot>
    </div>
  </header>
</template>
<script>
/**
   * @param title [String] 标题
   * @param tleft [Object] 左边内容包含icon(图标)，text(文字)
   * @param tright [Object] 右边内容包含icon(图标)，text(文字)
   * @param isfixed [Boolean] 是否固定在顶部,默认true
   * @param on-left [Function] 点击左边事件
   * @param on-right [Function] 点击右边事件
   * @param on-center [Function] 点击标题事件
   * @describe 当tleft的icon为back是默认事件为返回上一页,如需自定义可考虑用back1
   *
   * @example
   *
    <t-header title="标题" :tleft='{icon:"back",text: "返回"}' @on-left='$router.push("/")'></t-header>
   */


export default {
  name: 'tHeader',
  props: {
    title: String,
    tleft: {
      type: Object,
      default() {
        return {};
      },
    },
    tright: {
      type: Object,
      default() {
        return {};
      },
    },
    isfixed: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onEmit(name) {
      if (this.tleft.icon === 'back' && name === 'left') {
        this.$router.go(-1);
        return;
      }
      this.$emit(`on-${name}`);
    },
  },
};

</script>
<style lang="scss">
.t-header {
  display: flex;
  font-size: 16px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  z-index: 9;
  padding: 0 15px;
  background-color: #000;
  color: #FFFFFF;
  &.is-fixed {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
  }
  &>h1 {
    flex: 1;
    color: #FFFFFF;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .header-left {
    text-align: left;
    flex: 0 0 88px;
    font-size: 15px;
    color: #ffffff;
    background: none;
    i {
      color: #ffffff;
      float: left;
      font-size: 18px;
    }
    span{
      color: #ffffff;
      font-size: 11px;
    }
  }
  .header-right {
    text-align: right;
    flex: 0 0 88px;
    font-size: 15px;
    color: #ffffff;
    background: none;
    span{
      color: #fff;
    }
    i {
      color: #ffffff;
      float: right;
      font-size: 18px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/header.vue